import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

const experiences = [
  {
    id: 1,
    role: 'Principal Software Engineer',
    company: 'Soliton Technologies',
    duration: 'Nov 2019 - Dec 2024',
    responsibilities: [
      'Led development of scalable web, mobile, and desktop applications using Xamarin Forms, Python/Django, ASP.NET (Web Forms, MVC and Core) and ReactJS.',
      'Designed and implemented RESTful APIs for seamless system integration.',
      'Managed database design and optimization across MS SQL Server, PostgreSQL, and ClickHouse DB.',
      'Integrated third-party controls (Telerik) to enhance UI/UX.',
      'Developed front-end solutions with JavaScript, HTML5, CSS3, and ReactJS for responsive, dynamic interfaces.',
      'Created and optimized stored procedures, triggers, and views for efficient database performance.',
      'Collaborated with cross-functional teams, ensuring high-quality product delivery and Agile process adherence.',
      'Mentored junior developers and conducted code reviews to promote best practices.',
    ],
    flip: 'flip-left',
  },
  {
    id: 2,
    role: 'Senior Software Engineer',
    company: 'FutureNow Technologies',
    duration: 'Jan 2016 - Oct 2019',
    responsibilities: [
      'Worked on ASP.NET Web Forms, ASP.NET MVC and ASP.NET Windows Forms to create web and Desktop applications using ADO.NET and Entity Framework.',
      'Built and maintained RESTful APIs.',
      'Developed console applications to support applications running live to update databases and scheduled jobs to send emails to respective recipients.',
      'Optimized databases (SQL Server) including stored procedures and views.',
      'Integrated Telerik controls to enhance UI/UX.',
      'Implemented responsive front-end solutions with JavaScript, HTML5, CSS3.',
      'Collaborated with teams to ensure high-quality software delivery and code best practices.',
    ],
    flip: 'flip-right',
  },
  {
    id: 3,
    role: 'Software Engineer',
    company: 'Digital Logix',
    duration: 'Feb 2014 - Dec 2015',
    responsibilities: [
      'Worked on ASP.NET Web Forms and ASP.NET Windows Forms to create web and Desktop applications using ADO.NET and Entity Framework.',
      'Built and maintained RESTful APIs, WCF, and ASMX web services.',
      'Optimized databases (SQL Server) including stored procedures and views.',
      'Integrated Telerik and Infragistics controls to enhance UI/UX.',
      'Implemented responsive front-end solutions with JavaScript, HTML5, CSS3.',
      'Collaborated with teams.',
    ],
    flip: 'flip-left',
  },
]

export default function WorkExperience() {
  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])

  return (
    <div id="experience" className=" px-6 sm:px-12 lg:px-20">
      <h2 className="text-lg leading-7">My Professional</h2>
      <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
        Work Experience
      </p>

      <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-2">
        {experiences.map((exp) => (
          <div
            key={exp.id}
            className="group relative ring-2 ring-base-300 bg-base-200 rounded-2xl shadow-xl p-6"
            data-aos={exp.flip}
          >
            <h3 className="text-xl font-bold text-base-content">
              {exp.role},{' '}
              <span className="text-base-content">{exp.company}</span>
            </h3>

            <p className="text-sm text-gray-400">{exp.duration}</p>
            <ul className="mt-4 text-sm list-disc pl-5 space-y-2">
              {exp.responsibilities.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}
